import { Page } from '@/core/architecture'

import { ConsolePreSaleEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsolePreSaleEdit Page
 * Implemented as a practical sample.
 */
export const ConsolePreSaleEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsolePreSaleEditTemplate state={state} {...actions} />
}
